<template>
  <b-card>
    <!-- Header -->
    <div class="d-flex align-items-center justify-content-between mb-2">
      <div>
        <h4 class="mb-0">Multi Fixed Limits</h4>
        <p class="text-muted mb-0">
          Configure multi bet liability limits per customer profile. Rules are matched by legs, stake band, and odds band.
        </p>
      </div>
      <div>
        <input type="file" ref="fileInput" class="d-none" accept=".csv" @change="handleFileUpload" />
        <b-button size="sm" variant="outline-primary" class="mr-1" @click="$refs.fileInput.click()">
          <feather-icon icon="UploadIcon" class="mr-50" />
          <span class="align-middle">Upload CSV</span>
        </b-button>
         <a
            href="/template_config_multi_fixed_limits.csv"
            download="template_config_multi_fixed_limits.csv"
            class="download-button mr-1"
            variant="outline-success"
          >
            <feather-icon icon="ArrowDownIcon" />
            Sample CSV
          </a>
      </div>
    </div>

    <!-- General Profile Info -->
    <div class="bg-light p-1 rounded mb-2 border">
      <div class="d-flex align-items-center justify-content-between">
        <div>
          <h5 class="mb-0"> <b-button
          variant="outline"
          class="mr-2 text font-weight-bolder"
          :style="{ backgroundColor: getColorFromProfileName(activeProfile) }"
          style="color: white"
        >
          {{ activeProfile }}</b-button
        > Profile — Multi Fixed Liability Table</h5>
          <small class="text-muted">If a rule matches, max liability is applied. If NO rule matches, bet is accepted in full.</small>
        </div>
        <!-- <b-button variant="outline-primary" size="sm" @click="addRule">
          <feather-icon icon="PlusIcon" class="mr-50" />
          <span class="align-middle">Add Rule</span>
        </b-button> -->
      </div>
    </div>

    <!-- Accordions -->
    <div class="accordion" role="tablist">
      
      <!-- 2-4 Legs -->
      <b-card no-body class="mb-1 border">
        <b-card-header header-tag="header" class="p-1" role="tab" @click="togglePanel('2-4')">
            <div block variant="info" class="d-flex justify-content-between align-items-center cursor-pointer text-primary font-weight-bold">
                 <span>
                     <b-badge variant="primary" class="mr-1">2-4 Legs</b-badge>
                     <span class="text-muted">{{ rules['2-4'].length }} rules configured</span>
                 </span>
                 <feather-icon :icon="openedPanel === '2-4' ? 'ChevronUpIcon' : 'ChevronDownIcon'" />
            </div>
        </b-card-header>
        <b-collapse :visible="openedPanel === '2-4'" role="tabpanel">
          <b-card-body class="p-0">
            <rules-table :items="rules['2-4']" @delete="deleteRule('2-4', $event)" @edit="getRuleForEdit('2-4', $event)" />
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- 5-10 Legs -->
      <b-card no-body class="mb-1 border">
        <b-card-header header-tag="header" class="p-1" role="tab" @click="togglePanel('5-10')">
            <div block variant="info" class="d-flex justify-content-between align-items-center cursor-pointer text-primary font-weight-bold">
                 <span>
                     <b-badge variant="primary" class="mr-1">5-10 Legs</b-badge>
                     <span class="text-muted">{{ rules['5-10'].length }} rules configured</span>
                 </span>
                 <feather-icon :icon="openedPanel === '5-10' ? 'ChevronUpIcon' : 'ChevronDownIcon'" />
            </div>
        </b-card-header>
        <b-collapse :visible="openedPanel === '5-10'" role="tabpanel">
           <b-card-body class="p-0">
            <rules-table :items="rules['5-10']" @delete="deleteRule('5-10', $event)" @edit="getRuleForEdit('5-10', $event)" />
          </b-card-body>
        </b-collapse>
      </b-card>

       <!-- 11-20 Legs -->
      <b-card no-body class="mb-1 border">
        <b-card-header header-tag="header" class="p-1" role="tab" @click="togglePanel('11-20')">
            <div block variant="info" class="d-flex justify-content-between align-items-center cursor-pointer text-primary font-weight-bold">
                 <span>
                     <b-badge variant="primary" class="mr-1">11-20 Legs</b-badge>
                     <span class="text-muted">{{ rules['11-20'].length }} rules configured</span>
                 </span>
                 <feather-icon :icon="openedPanel === '11-20' ? 'ChevronUpIcon' : 'ChevronDownIcon'" />
            </div>
        </b-card-header>
        <b-collapse :visible="openedPanel === '11-20'" role="tabpanel">
           <b-card-body class="p-0">
            <rules-table :items="rules['11-20']" @delete="deleteRule('11-20', $event)" @edit="getRuleForEdit('11-20', $event)" />
          </b-card-body>
        </b-collapse>
      </b-card>

    </div>

    <!-- Footer / Validation -->
    <div class="mt-2">
      <span class="text-muted font-weight-bold">Validation Rules: </span> Odds must be ≥ 1.01 | No overlapping ranges allowed | Lowest allowed stake always wins
    </div>
    <div style="color: #d63384">
     <span class="font-weight-bold text-muted">Formula:</span>   exposure = stake × odds | allowed_stake = min(stake, max_liability / odds, profile_max_payout / odds)
    </div>

    <!-- Action Buttons -->
    <div class="d-flex justify-content-end mt-2">
        <b-button variant="outline-secondary" class="mr-1" @click="resetToDefaults">Reset to Defaults</b-button>
        <b-button variant="primary" :disabled="!isUploadedFromCSV" @click="saveConfiguration">Save Configuration</b-button>
    </div>

      <!-- MODAL CONFIRM -->
    <b-modal
      ref="modal"
      :title="modal.title"
      centered
      cancel-variant="outline-secondary"
      :ok-disabled="isSubmitting"
      @ok="handleSubmitModal"
    >
      <b-card-text style="color: black">
        {{ modal.content }}
      </b-card-text>
      <template #modal-ok>
        <b-spinner small v-if="isSubmitting" />
        <span v-else>Submit</span>
      </template>
    </b-modal>

  </b-card>
</template>

<script>
import {
  BCard,
  BButton,
  BCollapse,
  BCardHeader,
  BCardBody,
  BBadge,
  BModal,
  BSpinner,
  BCardText
} from "bootstrap-vue";
import RulesTable from "./MultiFixedLimits/RulesTable.vue";
import { mapActions, mapState } from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BCard,
    BButton,
    BCollapse,
    BCardHeader,
    BCardBody,
    BBadge,
    RulesTable,
    BCardText 
  },
  data() {
    return {
      rules: {
        '2-4': [], 
        '5-10': [],
        '11-20': []
      },
      openedPanel: '2-4', // Default open
      isUploadedFromCSV: false, // Track CSV upload status
      modal: {
        title: "",
        content: "",
      },
      action: {
        type: "",
        item: "",
      },
    };
  },
  computed: {
    ...mapState("bettingConfig/list", ["activeProfile"]),
    ...mapState("bettingConfig/multiBet", ["loadingDelete", "loadingUpset"]),
    isSubmitting() {
      return this.loadingDelete || this.loadingUpset;
    },
  },
  watch: {
    activeProfile: {
      immediate: true,  
      handler(newVal) {
        if (newVal) {
          this.fetchAllRules();
        }
      }
    }
  },
  methods: {
    ...mapActions("bettingConfig/multiBet", ["getConfigMultiBetList", "createConfigMultiBet", "deleteConfigMultiBet", "deleteAllConfigMultiBet", "updateConfigMultiBet"]),
       getColorFromProfileName(name) {
      const colorList = [
        "#5A6A7A",
        "#F48FB1",
        "#8BC34A",
        "#F44336",
        "#FFEB3B",
        "#FF9800",
        "#03A9F4",
        "#4CAF50",
      ];
      if (!name || colorList.length === 0) {
        return "#CCCCCC";
      }
      let hash = 0;
      const cleanName = name.toLowerCase();

      for (let i = 0; i < cleanName.length; i++) {
        hash += cleanName.charCodeAt(i);
      }
      const colorIndex = hash % colorList.length;

      return colorList[colorIndex];
    },
    async fetchAllRules() {
        if (!this.activeProfile) return;
        
        try {
            const res = await this.getConfigMultiBetList({
                profileTypeId: this.activeProfile.id || this.activeProfile, 
                limit: 500 
            });
            
            // Reset rules
            this.rules = {
                '2-4': [],
                '5-10': [],
                '11-20': []
            };

            if (res && Array.isArray(res)) {
                res.forEach(item => {
                    const mappedItem = {
                        ...item,
                        legs: `${item.minLegs}-${item.maxLegs} Legs`,
                        stakeMin: item.minStake,
                        stakeMax: item.maxStake,
                        oddsMin: item.minOdds,
                        oddsMax: item.maxOdds,
                        status: item.status === 'active'
                    };

                    if (item.minLegs >= 2 && item.minLegs <= 4) {
                        this.rules['2-4'].push(mappedItem);
                    } else if (item.minLegs >= 5 && item.minLegs <= 10) {
                        this.rules['5-10'].push(mappedItem);
                    } else if (item.minLegs >= 11 && item.minLegs <= 20) {
                        this.rules['11-20'].push(mappedItem);
                    }
                });
            }

        } catch (error) {
            console.error("Error fetching multi bet config:", error);
             // Ensure reset on error
             this.rules = {
                '2-4': [],
                '5-10': [],
                '11-20': []
            };
        }
    },

    resetToDefaults() {
        this.fetchAllRules();
    },
    async saveConfiguration() {
        if (!this.activeProfile) return;

        // Gather all rules
        const allRules = [
            ...this.rules['2-4'],
            ...this.rules['5-10'],
            ...this.rules['11-20']
        ];

        // Format payload
        const payload = {
            bands: allRules.map(rule => {
                const [minLegs, maxLegs] = rule.legs.replace(' Legs', '').split('-').map(Number);
                return {
                    profileTypeId: this.activeProfile,
                    minLegs,
                    maxLegs,
                    minStake: rule.stakeMin,
                    maxStake: rule.stakeMax,
                    minOdds: rule.oddsMin,
                    maxOdds: rule.oddsMax,
                    maxLiability: rule.maxLiability,
                    status: rule.status ? 'active' : 'inactive' // Assuming status boolean -> string
                };
            })
        };

        try {
            // Delete all existing configurations first
            await this.deleteAllConfigMultiBet();
            
            // Then save the new configuration
            await this.createConfigMultiBet(payload);
            this.$toast({
                component: ToastificationContent,
                props: {
                    title: 'Success',
                    icon: 'CheckIcon',
                    variant: 'success',
                    text: 'Configuration saved successfully',
                },
            });
            this.isUploadedFromCSV = false; // Reset flag after successful save
            this.fetchAllRules(); // Refresh data
        } catch (error) {
            console.error("Save config error:", error);
             this.$toast({
                component: ToastificationContent,
                props: {
                    title: 'Error',
                    icon: 'AlertCircleIcon',
                    variant: 'danger',
                    text: 'Failed to save configuration',
                },
            });
        }
    },
    handleFileUpload(event) {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (e) => {
            const text = e.target.result;
            this.parseCSV(text);
        };
        reader.readAsText(file);
        // Reset input
        event.target.value = '';
    },
    parseCSV(text) {
        const lines = text.split('\n');
        // Skip header
        const dataLines = lines.slice(1);
        
        // Reset rules temporary
        const newRules = {
             '2-4': [],
             '5-10': [],
             '11-20': []
        };

        dataLines.forEach(line => {
            const cols = line.split(',').map(c => c.trim());
             // Ensure we have enough columns (headers: min_legs, max_legs, min_stake, max_stake, min_odds, max_odds, max_liability, Status)
            if (cols.length < 8) return;

            const [minLegsStr, maxLegsStr, minStake, maxStake, minOdds, maxOdds, maxLiability, status] = cols;
            const minLegs = Number(minLegsStr);
            const maxLegs = Number(maxLegsStr);
            
            if (isNaN(minLegs) || isNaN(maxLegs)) return;

            const mappedItem = {
                id: null, // Unsaved
                legs: `${minLegs}-${maxLegs} Legs`,
                stakeMin: minStake,
                stakeMax: maxStake,
                oddsMin: minOdds,
                oddsMax: maxOdds,
                maxLiability: maxLiability,
                status: status.toLowerCase() === 'active'
            };

            if (minLegs >= 2 && minLegs <= 4) {
                newRules['2-4'].push(mappedItem);
            } else if (minLegs >= 5 && minLegs <= 10) {
                newRules['5-10'].push(mappedItem);
            } else if (minLegs >= 11 && minLegs <= 20) {
                newRules['11-20'].push(mappedItem);
            }
        });
        
        this.rules = newRules;
        this.isUploadedFromCSV = true; // Enable Save button after CSV upload
        this.$toast({
            component: ToastificationContent,
            props: {
                title: 'CSV Uploaded',
                icon: 'CheckIcon',
                variant: 'success',
                text: 'Rules populated from CSV',
            },
        });
    },

    togglePanel(panelId) {
        if(this.openedPanel === panelId) {
            this.openedPanel = null;
        } else {
            this.openedPanel = panelId;
        }
    },
    addRule() {
      // Logic to determine which group to add to
      const targetGroup = this.openedPanel || '2-4';
      
      // Create new empty rule
      const newRule = {
          id: null, // Unsaved
          group: targetGroup,
          legs: `${targetGroup} Legs`, 
          stakeMin: '', 
          stakeMax: '', 
          oddsMin: '', 
          oddsMax: '', 
          maxLiability: '', 
          status: true
      };

      this.rules[targetGroup].unshift(newRule);
    },
    getRuleForEdit(group, index) {
        const item = this.rules[group][index];
        this.showModal('edit', item);
    },
    deleteRule(group, index) {
      const item = this.rules[group][index];
      this.showModal('delete', item);
    },
     setModal(title, content) {
      this.modal.title = title;
      this.modal.content = content;
    },

    showModal(type, item) {
      this.action = { item, type };
      if (type === "delete") {
        this.setModal(
          "Delete Rule",
          `Are you sure you want to delete the rule?`
        );
      }
      if (type === "status") {
        this.setModal(
          "Update Status Rule",
          `Are you sure you want to ${
            item.status === "active" ? "inactive" : "active"
          } the rule?`
        );
      }
      if (type === "edit") {
        this.setModal(
          "Update Rule",
          `Are you sure you want to update this rule?`
        );
      }
      this.$refs.modal.show();
    },

    async handleSubmitModal(event) {
      event.preventDefault();
      const { item, type } = this.action;

      if (type === "delete") await this.handleDeleteRule(item);
      if (type === "status") await this.handleChangeStatusRule(item);
      if (type === "edit") await this.handleEditRule(item);

      if (!this.isSubmitting) {
        this.$nextTick(() => {
          this.$refs.modal.hide();
        });
      }
    },
    async handleEditRule(item) {
        const [minLegs, maxLegs] = item.legs.replace(' Legs', '').split('-').map(Number);
        
        const data = {
            profileTypeId: this.activeProfile.id || this.activeProfile,
            minLegs,
            maxLegs,
            minStake: item.stakeMin,
            maxStake: item.stakeMax,
            minOdds: item.oddsMin,
            maxOdds: item.oddsMax,
            maxLiability: item.maxLiability,
            status: item.status ? 'active' : 'inactive' 
        };

        try {
            await this.updateConfigMultiBet({ id: item.id, ...data });
            this.$toast({
                component: ToastificationContent,
                props: {
                    title: 'Success',
                    icon: 'CheckIcon',
                    variant: 'success',
                    text: 'Rule updated successfully',
                },
            });
            this.fetchAllRules(); 
        } catch (error) {
            console.error("Update rule error:", error);
             this.$toast({
                component: ToastificationContent,
                props: {
                    title: 'Error',
                    icon: 'AlertCircleIcon',
                    variant: 'danger',
                    text: 'Failed to update rule',
                },
            });
        }
    },
    async handleDeleteRule(item) {
      try {
        await this.deleteConfigMultiBet(item.id);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Success",
            icon: "CheckIcon",
            variant: "success",
            text: "Rule deleted successfully",
          },
        });
        this.fetchAllRules();
      } catch (error) {
        console.error("Delete rule error:", error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error",
            icon: "AlertCircleIcon",
            variant: "danger",
            text: "Failed to delete rule",
          },
        });
      }
    },
    async handleChangeStatusRule(item) {
      try {
        await this.changeStatusRule(item.id);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Success",
            icon: "CheckIcon",
            variant: "success",
            text: "Rule status changed successfully",
          },
        });
        this.fetchAllRules();
      } catch (error) {
        console.error("Change status rule error:", error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error",
            icon: "AlertCircleIcon",
            variant: "danger",
            text: "Failed to change rule status",
          },
        });
      }
    },  
  }
};
</script>

<style lang="scss" scoped>
.accordion {
    .card {
        box-shadow: none;
        .card-header {
             background-color: transparent;
             border-bottom: none;
        }
    }
}
</style>
